import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Listas globales de sugerencias (headcount): usar list="catalogo-puestos" / list="catalogo-areas" en cualquier input
export default function CatalogoDatalists() {
  const [puestos, setPuestos] = useState([]);
  const [areas, setAreas] = useState([]);
  useEffect(() => {
    const load = () => {
      axios.get(`${API}/catalogs/puestos`, { withCredentials: true }).then((r) => setPuestos(r.data || [])).catch(() => {});
      axios.get(`${API}/catalogs/areas`, { withCredentials: true }).then((r) => setAreas((r.data || []).map((a) => a.nombre))).catch(() => {});
    };
    load();
    window.addEventListener("catalogos:refresh", load);
    return () => window.removeEventListener("catalogos:refresh", load);
  }, []);
  return (
    <>
      <datalist id="catalogo-puestos" data-testid="datalist-puestos">{puestos.map((p) => <option key={p} value={p} />)}</datalist>
      <datalist id="catalogo-areas" data-testid="datalist-areas">{areas.map((a) => <option key={a} value={a} />)}</datalist>
    </>
  );
}
